function getSupportedPropertyName(properties) {
	let activePropety = null;

	properties.forEach((property) => {
		if (typeof (document.body.style[property]) !== "undefined" && !activePropety) {
			activePropety = property;
		}
	});

	return activePropety;
}

export function getSupportedTransform() {
	const transforms = ["transform", "msTransform", "webkitTransform",
		"mozTransform", "oTransform"];

	return getSupportedPropertyName(transforms);
}



// WEBPACK FOOTER //
// ./src/shared/util/Prefixes.js